import { produce } from 'immer';

import {
  SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST,
  SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { SigningProgressInformationAction } from '@app/store/signingProgressInformation/actions';

interface SigningProgressInformationHistory {
  content: string;
  timestamp: string;
  userIp: string | null;
}

export type SigningProgressInformationHistoriesState = SigningProgressInformationHistory[];

const initialState: SigningProgressInformationHistoriesState = [];

export default function reducer(
  state: SigningProgressInformationHistoriesState = initialState,
  action: SigningProgressInformationAction
) {
  switch (action.type) {
    case SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST:
      return initialState;
    case SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS:
      return produce(state, (draft) => {
        if (action.payload) {
          const { histories } = action.payload;

          histories.forEach((history) => {
            draft.push({
              content: history.content,
              userIp: history.actionGenerator && history.actionGenerator.userIp,
              timestamp: history.timestamp,
            });
          });
        }
      });
    default:
      return state;
  }
}
